import { api, handleResponse } from "@/api/config";

export const destinationService = {

  // =====================================================
  // GET ALL
  // =====================================================

  getAll: async (params = {}) => {

    const res = await api.get(
      "/destinations",
      { params }
    );

    return handleResponse(res);
  },

  // =====================================================
  // GET SINGLE
  // =====================================================

  getById: async (id) => {

    const res = await api.get(
      `/destinations/${id}`
    );

    return handleResponse(res);
  },

  // =====================================================
  // CREATE
  // =====================================================

  create: async (data) => {

    const res = await api.post(
      "/destinations",
      data
    );

    return handleResponse(res);
  },

  // =====================================================
  // UPDATE
  // =====================================================

  update: async (id, data) => {

    const res = await api.put(
      `/destinations/${id}`,
      data
    );

    return handleResponse(res);
  },

  // =====================================================
  // DELETE
  // =====================================================

  delete: async (id) => {

    const res = await api.delete(
      `/destinations/${id}`
    );

    return handleResponse(res);
  },

  // =====================================================
  // IMAGE UPLOAD
  // =====================================================

  uploadImage: async (file) => {

    const formData = new FormData();

    formData.append(
      "image",
      file
    );

    const res = await api.post(
      "/destinations/upload",
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    return handleResponse(res);
  },
};

export default destinationService;
